import { makeStyles } from '@material-ui/core';


export default makeStyles(() => ({
  root: {
    background: 'url(/assets/footer.png) right',
    backgroundSize: '200px',
    backgroundRepeat: 'no-repeat',
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
}));